import { useQuery } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  TransferStatusEntity,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

export const useGetBidvTransferStatusQuery = (
  transactionCode: string,
  enabled: boolean = false,
) => {
  const queryKey = [
    BidvBankTransferServiceKeys.GET_TRANSFER_STATUS,
    transactionCode,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<TransferStatusEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvBankTransferService.bidvBankTransferControllerGetTransferStatus(
        transactionCode,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!transactionCode,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
